export type PopoverMessages = {
  updatePopover: string;
  removePopover: string;
  cancelPopover: string;
  printPopover: string;
  viewPopover: string;
};

export const POPOVER_MESSAGES: PopoverMessages = {
  updatePopover: "Editar",
  removePopover: "Remover",
  cancelPopover: "Cancelar",
  printPopover: "Imprimir",
  viewPopover: "Visualizar",
};
